(() => {
  const key = 'filter.v.m.custom.metal_combination';
  const oldKey = 'filter.p.m.custom.metal_type';
  const purities = ['18ct Gold', '14ct Gold', '9ct Gold'];
  const colours = ['Yellow Gold', 'White Gold', 'Rose Gold', 'Two Tone', 'Three Tone'];
  const mixed = '18ct Gold / Yellow Gold + Platinum 950';
  const params = () => new URLSearchParams(location.search);
  const previewId = () => params().get('preview_theme_id') || (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id ? String(window.Shopify.theme.id) : null);
  const selected = () => new Set(params().getAll(key).flatMap(v => v.split(',')));
  function navigate(p, drawer = true) {
    const metals = [...new Set(p.getAll(key).flatMap(v => v.split(',')))];
    p.delete(key); metals.forEach(v => p.append(key, v));
    const preview = previewId();
    p.delete('preview_theme_id');
    if (!p.getAll('filter.p.t.category').includes('aa-6-9-2')) p.delete('filter.p.m.custom.stone_shape');
    if (drawer) sessionStorage.setItem('kekilli-metal-drawer', 'open');
    location.assign(location.pathname + '?' + p.toString());
  }
  function submit(form) {
    const p = new URLSearchParams(new FormData(form));
    p.delete(oldKey); p.delete('page');
    for (const [k,v] of [...p]) if (v === '') p.delete(k);
    if (location.pathname === '/search') {
      for (const k of ['q','type','options[prefix]']) if (!p.has(k) && params().has(k)) p.set(k,params().get(k));
    }
    navigate(p);
  }
  let timer;
  document.addEventListener('input', event => {
    const input = event.target;
    const form = input.closest('.FacetFiltersForm');
    if (!form) return;
    if (input.type === 'range') {
      const range = input.closest('price-range');
      const amounts = [...range.querySelectorAll('input[type="range"]')].map(i=>Number(i.value)).sort((a,b)=>a-b);
      range.querySelector('input[name="filter.v.price.gte"]').value = amounts[0];
      range.querySelector('input[name="filter.v.price.lte"]').value = amounts[1];
    }
    event.stopImmediatePropagation();
    clearTimeout(timer);
    if (input.type === 'number' || input.type === 'range') timer = setTimeout(() => submit(form),600);
    else submit(form);
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches('.FacetFiltersForm')) return;
    event.preventDefault(); event.stopImmediatePropagation(); submit(event.target);
  }, true);
  document.addEventListener('click', event => {
    const label = event.target.closest('.FacetFiltersForm label[for]');
    const input = label && document.getElementById(label.htmlFor);
    if (input?.type === 'checkbox' && event.target !== input) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!input.disabled) {input.checked = !input.checked; submit(input.closest('form'));}
      return;
    }
    const link = event.target.closest('facet-remove a');
    if (link) {event.preventDefault();event.stopImmediatePropagation();navigate(new URL(link.href).searchParams);}
  }, true);
  function setup() {
    const active = selected();
    document.querySelectorAll('.FacetFiltersForm').forEach((form, fi) => {
      if (form.querySelector('.kekilli-native-metal')) return;
      const raw = [...form.querySelectorAll(`input[name="${key}"]`)];
      const values = [...new Set([...raw.map(i=>i.value),mixed])];
      const available = new Set(raw.filter(i=>!i.disabled).map(i=>i.value));
      const original = form.querySelector(`input[name="${oldKey}"]`)?.closest('.js-filter');
      const rawGroup = raw[0]?.closest('.js-filter');
      [original,rawGroup].filter(Boolean).forEach(g => {g.hidden=true;g.style.display='none';g.querySelectorAll('input').forEach(i=>i.disabled=true);});
      const group = document.createElement('section');group.className='kekilli-native-metal';
      group.style.cssText='margin:24px 0';
      const title=document.createElement('h3');title.textContent='Metal Type';title.style.cssText='font-size:24px;margin:0 0 14px';group.append(title);
      function choice(pair,label,parent,id) {
        const matching=values.filter(v=>v.split(' + ').includes(pair));
        const encoded=[...new Set([pair,...matching])].join(',');
        const row=document.createElement('label');row.className='kekilli-native-metal-choice';row.style.cssText='display:flex;align-items:center;gap:9px;padding:7px 0;font-size:14px';
        const input=document.createElement('input');input.type='checkbox';input.name=key;input.value=encoded;input.dataset.metalPair=pair;input.id=`kekilli-native-metal-${fi}-${id}`;input.checked=active.has(pair);input.disabled=!input.checked&&!matching.some(v=>available.has(v));
        row.htmlFor=input.id;const text=document.createElement('span');text.textContent=label;row.append(input,text);if(input.disabled)row.style.opacity='.45';parent.append(row);
      }
      purities.forEach((purity,pi)=>{
        const details=document.createElement('details');details.dataset.metalPurity=purity;details.style.cssText='margin-bottom:10px';
        const summary=document.createElement('summary');summary.textContent=purity;summary.style.cssText='cursor:pointer;padding:8px 0;font-size:16px';details.append(summary);
        const children=document.createElement('div');children.style.cssText='margin-left:14px;padding-left:14px;border-left:1px solid #ddd';
        colours.forEach((colour,ci)=>choice(purity+' / '+colour,colour,children,pi+'-'+ci));details.append(children);
        details.open=[...active].some(v=>v.startsWith(purity+' / '))||sessionStorage.getItem('kekilli-metal-open-'+purity)==='true';
        details.addEventListener('toggle',()=>sessionStorage.setItem('kekilli-metal-open-'+purity,String(details.open)));group.append(details);
      });
      choice('Platinum 950','Platinum 950',group,'platinum');choice('Silver 925','Silver 925',group,'silver');
      if (active.size) {const clear=document.createElement('button');clear.type='button';clear.textContent='Clear metal filters';clear.style.cssText='margin-top:10px;padding:8px 10px';clear.addEventListener('click',()=>{const p=params();p.delete(key);p.delete('page');navigate(p);});group.append(clear);}
      if(original)original.after(group);else if(rawGroup)rawGroup.after(group);else form.append(group);
    });
    document.querySelectorAll('facet-remove').forEach(e=>{if(e.textContent.includes('Metal Combination'))e.hidden=true;});
    const preview=previewId();
    if(preview)document.querySelectorAll('#JsCollectionProduct a[href*="/products/"]').forEach(a=>{const u=new URL(a.href);u.searchParams.set('preview_theme_id',preview);a.href=u.href;});
    if(sessionStorage.getItem('kekilli-metal-drawer')==='open'){sessionStorage.removeItem('kekilli-metal-drawer');document.body.classList.add('collection-sidebar--open');}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  window.addEventListener('pageshow',()=>{const active=selected();document.querySelectorAll('[data-metal-pair]').forEach(i=>i.checked=active.has(i.dataset.metalPair));});
})();





function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
		this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('.FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    const normalizedParams = new URLSearchParams(searchParams);
    if (!normalizedParams.getAll('filter.p.t.category').includes('aa-6-9-2')) {
      normalizedParams.delete('filter.p.m.custom.stone_shape');
    }
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme) normalizedParams.set('preview_theme_id', previewTheme);
    searchParams = normalizedParams.toString();
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?block_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
	const myTimeout = setTimeout(removeLoad, 1000);
	var element = document.getElementById("pre-loading");
	element.classList.add("load-product");
	document.querySelector('.pre-loading__bar').style.width = '40%'
    document.getElementById('JsCollectionProduct').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('JsCollectionProduct').innerHTML;
    document.querySelector('.facet-filters.sorting').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.facet-filters.sorting').innerHTML;
	setTimeout(function() {
		document.querySelector('.pre-loading__bar').style.width = '100%'
	}, 500);
	function removeLoad() {
		document.querySelector('.pre-loading__bar').style.width = '0'
		element.classList.remove("load-product");
	}
	$('.product-card__image-wrapper.slider').each(function() {
        wpbingo.load_swiper_carousel($('.bwp-swiper-slider',$(this)));
	});
	if( $('.bwp_currency').length > 0){ Currency.Currency_customer(true); }
	wpbingo.click_atribute_image();
	wpbingo.zoom_thumb();
	if(window.SPR){
		SPR.initRatingHandler ();
		SPR.initDomEls ();
		SPR.loadProducts ();
		SPR.loadBadges ();
	}
	wpbingo.countdown();
	initButtons();
	initButtonsCompare();
	wpbingo.countActiveSidebar();
	wpbingo.toggleSidebar(true);
	wpbingo.sidebarCollection(true);
	wpbingo.ajaxFilterCategory();
	wpbingo.product_result_count();
	cViewCollection = wpbingo.getCookie('wpbingo_view_collection');
	if(cViewCollection){
		$('#JsCollectionProduct').removeAttr('class');
		$('#JsCollectionProduct').addClass(cViewCollection);
		$('.js-change-view').removeClass('active');
		$('[data-view='+cViewCollection+']').addClass('active');
	}
	$('.js-page-collection').on('click', '.js-change-view', function(e) {
		e.preventDefault();
		if (!$(this).hasClass('active')) {
			wpbingo.setCookie("wpbingo_view_collection", $(this).data('view'), 30);
			$('.js-change-view').removeClass('active');
			$(this).addClass('active');
			$('#JsCollectionProduct').removeAttr('class');
			$('#JsCollectionProduct').addClass($(this).data('view'));
		}
	});
  }

  static renderFilters(html, event) {
    document.querySelectorAll('.kekilli-stone-shape').forEach((group) => {
      group.closest('form').querySelector('.FacetsWrapperDesktop').append(group);
    });
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.FacetFiltersForm .js-filter');
    const matchesIndex = (element) => {
		const jsFilter = event ? event.target.closest('.js-filter') : undefined;
		//return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
		document.querySelectorAll(`.FacetFiltersForm .js-filter[data-index="${element.dataset.index}"]`).forEach((target) => {
          target.innerHTML = element.innerHTML;
        });
    });
    KekilliStoneShape.refresh();
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
	
    const activeFacetElementSelectors = ['.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelectorAll(selector).forEach((target) => {
        target.innerHTML = activeFacetsElement.innerHTML;
      });
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    KekilliStoneShape.refresh();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
	this.loadRangePrice();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
	this.loadRangePrice();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  
  loadRangePrice(format) {
	var parent = document.querySelector(".facets__price");
	if(!parent) return;
    var moneyFormats = {
	  "USD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} USD"
	  },
	  "EUR": {
		"money_format": "&euro;{{amount}}",
		"money_with_currency_format": "&euro;{{amount}} EUR"
	  },
	  "GBP": {
		"money_format": "&pound;{{amount}}",
		"money_with_currency_format": "&pound;{{amount}} GBP"
	  },
	  "CAD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} CAD"
	  },
	  "ALL": {
		"money_format": "Lek {{amount}}",
		"money_with_currency_format": "Lek {{amount}} ALL"
	  },
	  "DZD": {
		"money_format": "DA {{amount}}",
		"money_with_currency_format": "DA {{amount}} DZD"
	  },
	  "AOA": {
		"money_format": "Kz{{amount}}",
		"money_with_currency_format": "Kz{{amount}} AOA"
	  },
	  "ARS": {
		"money_format": "${{amount_with_comma_separator}}",
		"money_with_currency_format": "${{amount_with_comma_separator}} ARS"
	  },
	  "AMD": {
		"money_format": "{{amount}} AMD",
		"money_with_currency_format": "{{amount}} AMD"
	  },
	  "AWG": {
		"money_format": "Afl{{amount}}",
		"money_with_currency_format": "Afl{{amount}} AWG"
	  },
	  "AUD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} AUD"
	  },
	  "BBD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} Bds"
	  },
	  "AZN": {
		"money_format": "m.{{amount}}",
		"money_with_currency_format": "m.{{amount}} AZN"
	  },
	  "BDT": {
		"money_format": "Tk {{amount}}",
		"money_with_currency_format": "Tk {{amount}} BDT"
	  },
	  "BSD": {
		"money_format": "BS${{amount}}",
		"money_with_currency_format": "BS${{amount}} BSD"
	  },
	  "BHD": {
		"money_format": "{{amount}} BD",
		"money_with_currency_format": "{{amount}} BHD"
	  },
	  "BYR": {
		"money_format": "Br {{amount}}",
		"money_with_currency_format": "Br {{amount}} BYR"
	  },
	  "BZD": {
		"money_format": "BZ${{amount}}",
		"money_with_currency_format": "BZ${{amount}} BZD"
	  },
	  "BTN": {
		"money_format": "Nu {{amount}}",
		"money_with_currency_format": "Nu {{amount}} BTN"
	  },
	  "BAM": {
		"money_format": "KM {{amount_with_comma_separator}}",
		"money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
	  },
	  "BRL": {
		"money_format": "R$ {{amount_with_comma_separator}}",
		"money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
	  },
	  "BOB": {
		"money_format": "Bs{{amount_with_comma_separator}}",
		"money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
	  },
	  "BWP": {
		"money_format": "P{{amount}}",
		"money_with_currency_format": "P{{amount}} BWP"
	  },
	  "BND": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} BND"
	  },
	  "BGN": {
		"money_format": "{{amount}} D�D�",
		"money_with_currency_format": "{{amount}} D�D� BGN"
	  },
	  "MMK": {
		"money_format": "K{{amount}}",
		"money_with_currency_format": "K{{amount}} MMK"
	  },
	  "KHR": {
		"money_format": "KHR{{amount}}",
		"money_with_currency_format": "KHR{{amount}}"
	  },
	  "KYD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} KYD"
	  },
	  "XAF": {
		"money_format": "FCFA{{amount}}",
		"money_with_currency_format": "FCFA{{amount}} XAF"
	  },
	  "CLP": {
		"money_format": "${{amount_no_decimals}}",
		"money_with_currency_format": "${{amount_no_decimals}} CLP"
	  },
	  "CNY": {
		"money_format": "&#165;{{amount}}",
		"money_with_currency_format": "&#165;{{amount}} CNY"
	  },
	  "COP": {
		"money_format": "${{amount_with_comma_separator}}",
		"money_with_currency_format": "${{amount_with_comma_separator}} COP"
	  },
	  "CRC": {
		"money_format": "&#8353; {{amount_with_comma_separator}}",
		"money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
	  },
	  "HRK": {
		"money_format": "{{amount_with_comma_separator}} kn",
		"money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
	  },
	  "CZK": {
		"money_format": "{{amount_with_comma_separator}} K&#269;",
		"money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
	  },
	  "DKK": {
		"money_format": "{{amount_with_comma_separator}}",
		"money_with_currency_format": "kr.{{amount_with_comma_separator}}"
	  },
	  "DOP": {
		"money_format": "RD$ {{amount}}",
		"money_with_currency_format": "RD$ {{amount}}"
	  },
	  "XCD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "EC${{amount}}"
	  },
	  "EGP": {
		"money_format": "LE {{amount}}",
		"money_with_currency_format": "LE {{amount}} EGP"
	  },
	  "ETB": {
		"money_format": "Br{{amount}}",
		"money_with_currency_format": "Br{{amount}} ETB"
	  },
	  "XPF": {
		"money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
		"money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
	  },
	  "FJD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "FJ${{amount}}"
	  },
	  "GMD": {
		"money_format": "D {{amount}}",
		"money_with_currency_format": "D {{amount}} GMD"
	  },
	  "GHS": {
		"money_format": "GH&#8373;{{amount}}",
		"money_with_currency_format": "GH&#8373;{{amount}}"
	  },
	  "GTQ": {
		"money_format": "Q{{amount}}",
		"money_with_currency_format": "{{amount}} GTQ"
	  },
	  "GYD": {
		"money_format": "G${{amount}}",
		"money_with_currency_format": "${{amount}} GYD"
	  },
	  "GEL": {
		"money_format": "{{amount}} GEL",
		"money_with_currency_format": "{{amount}} GEL"
	  },
	  "HNL": {
		"money_format": "L {{amount}}",
		"money_with_currency_format": "L {{amount}} HNL"
	  },
	  "HKD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "HK${{amount}}"
	  },
	  "HUF": {
		"money_format": "{{amount_no_decimals_with_comma_separator}}",
		"money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
	  },
	  "ISK": {
		"money_format": "{{amount_no_decimals}} kr",
		"money_with_currency_format": "{{amount_no_decimals}} kr ISK"
	  },
	  "INR": {
		"money_format": "Rs. {{amount}}",
		"money_with_currency_format": "Rs. {{amount}}"
	  },
	  "IDR": {
		"money_format": "{{amount_with_comma_separator}}",
		"money_with_currency_format": "Rp {{amount_with_comma_separator}}"
	  },
	  "ILS": {
		"money_format": "{{amount}} NIS",
		"money_with_currency_format": "{{amount}} NIS"
	  },
	  "JMD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} JMD"
	  },
	  "JPY": {
		"money_format": "&#165;{{amount_no_decimals}}",
		"money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
	  },
	  "JEP": {
		"money_format": "&pound;{{amount}}",
		"money_with_currency_format": "&pound;{{amount}} JEP"
	  },
	  "JOD": {
		"money_format": "{{amount}} JD",
		"money_with_currency_format": "{{amount}} JOD"
	  },
	  "KZT": {
		"money_format": "{{amount}} KZT",
		"money_with_currency_format": "{{amount}} KZT"
	  },
	  "KES": {
		"money_format": "KSh{{amount}}",
		"money_with_currency_format": "KSh{{amount}}"
	  },
	  "KWD": {
		"money_format": "{{amount}} KD",
		"money_with_currency_format": "{{amount}} KWD"
	  },
	  "KGS": {
		"money_format": "D�D�{{amount}}",
		"money_with_currency_format": "D�D�{{amount}}"
	  },
	  "LVL": {
		"money_format": "Ls {{amount}}",
		"money_with_currency_format": "Ls {{amount}} LVL"
	  },
	  "LBP": {
		"money_format": "L&pound;{{amount}}",
		"money_with_currency_format": "L&pound;{{amount}} LBP"
	  },
	  "LTL": {
		"money_format": "{{amount}} Lt",
		"money_with_currency_format": "{{amount}} Lt"
	  },
	  "MGA": {
		"money_format": "Ar {{amount}}",
		"money_with_currency_format": "Ar {{amount}} MGA"
	  },
	  "MKD": {
		"money_format": "??? {{amount}}",
		"money_with_currency_format": "??? {{amount}} MKD"
	  },
	  "MOP": {
		"money_format": "MOP${{amount}}",
		"money_with_currency_format": "MOP${{amount}}"
	  },
	  "MVR": {
		"money_format": "Rf{{amount}}",
		"money_with_currency_format": "Rf{{amount}} MRf"
	  },
	  "MXN": {
		"money_format": "$ {{amount}}",
		"money_with_currency_format": "$ {{amount}} MXN"
	  },
	  "MYR": {
		"money_format": "RM{{amount}} MYR",
		"money_with_currency_format": "RM{{amount}} MYR"
	  },
	  "MUR": {
		"money_format": "Rs {{amount}}",
		"money_with_currency_format": "Rs {{amount}} MUR"
	  },
	  "MDL": {
		"money_format": "{{amount}} MDL",
		"money_with_currency_format": "{{amount}} MDL"
	  },
	  "MAD": {
		"money_format": "{{amount}} dh",
		"money_with_currency_format": "Dh {{amount}} MAD"
	  },
	  "MNT": {
		"money_format": "{{amount_no_decimals}} &#8366",
		"money_with_currency_format": "{{amount_no_decimals}} MNT"
	  },
	  "MZN": {
		"money_format": "{{amount}} Mt",
		"money_with_currency_format": "Mt {{amount}} MZN"
	  },
	  "NAD": {
		"money_format": "N${{amount}}",
		"money_with_currency_format": "N${{amount}} NAD"
	  },
	  "NPR": {
		"money_format": "Rs{{amount}}",
		"money_with_currency_format": "Rs{{amount}} NPR"
	  },
	  "ANG": {
		"money_format": "&fnof;{{amount}}",
		"money_with_currency_format": "{{amount}} NA&fnof;"
	  },
	  "NZD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} NZD"
	  },
	  "NIO": {
		"money_format": "C${{amount}}",
		"money_with_currency_format": "C${{amount}} NIO"
	  },
	  "NGN": {
		"money_format": "&#8358;{{amount}}",
		"money_with_currency_format": "&#8358;{{amount}} NGN"
	  },
	  "NOK": {
		"money_format": "kr {{amount_with_comma_separator}}",
		"money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
	  },
	  "OMR": {
		"money_format": "{{amount_with_comma_separator}} OMR",
		"money_with_currency_format": "{{amount_with_comma_separator}} OMR"
	  },
	  "PKR": {
		"money_format": "Rs.{{amount}}",
		"money_with_currency_format": "Rs.{{amount}} PKR"
	  },
	  "PGK": {
		"money_format": "K {{amount}}",
		"money_with_currency_format": "K {{amount}} PGK"
	  },
	  "PYG": {
		"money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
		"money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
	  },
	  "PEN": {
		"money_format": "S/. {{amount}}",
		"money_with_currency_format": "S/. {{amount}} PEN"
	  },
	  "PHP": {
		"money_format": "&#8369;{{amount}}",
		"money_with_currency_format": "&#8369;{{amount}} PHP"
	  },
	  "PLN": {
		"money_format": "{{amount_with_comma_separator}} zl",
		"money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
	  },
	  "QAR": {
		"money_format": "QAR {{amount_with_comma_separator}}",
		"money_with_currency_format": "QAR {{amount_with_comma_separator}}"
	  },
	  "RON": {
		"money_format": "{{amount_with_comma_separator}} lei",
		"money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
	  },
	  "RUB": {
		"money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
		"money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
	  },
	  "RWF": {
		"money_format": "{{amount_no_decimals}} RF",
		"money_with_currency_format": "{{amount_no_decimals}} RWF"
	  },
	  "WST": {
		"money_format": "WS$ {{amount}}",
		"money_with_currency_format": "WS$ {{amount}} WST"
	  },
	  "SAR": {
		"money_format": "{{amount}} SR",
		"money_with_currency_format": "{{amount}} SAR"
	  },
	  "STD": {
		"money_format": "Db {{amount}}",
		"money_with_currency_format": "Db {{amount}} STD"
	  },
	  "RSD": {
		"money_format": "{{amount}} RSD",
		"money_with_currency_format": "{{amount}} RSD"
	  },
	  "SCR": {
		"money_format": "Rs {{amount}}",
		"money_with_currency_format": "Rs {{amount}} SCR"
	  },
	  "SGD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} SGD"
	  },
	  "SYP": {
		"money_format": "S&pound;{{amount}}",
		"money_with_currency_format": "S&pound;{{amount}} SYP"
	  },
	  "ZAR": {
		"money_format": "R {{amount}}",
		"money_with_currency_format": "R {{amount}} ZAR"
	  },
	  "KRW": {
		"money_format": "&#8361;{{amount_no_decimals}}",
		"money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
	  },
	  "LKR": {
		"money_format": "Rs {{amount}}",
		"money_with_currency_format": "Rs {{amount}} LKR"
	  },
	  "SEK": {
		"money_format": "{{amount_no_decimals}} kr",
		"money_with_currency_format": "{{amount_no_decimals}} kr SEK"
	  },
	  "CHF": {
		"money_format": "{{amount}} CHF",
		"money_with_currency_format": "{{amount}} CHF"
	  },
	  "TWD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} TWD"
	  },
	  "THB": {
		"money_format": "{{amount}} &#xe3f;",
		"money_with_currency_format": "{{amount}} &#xe3f; THB"
	  },
	  "TZS": {
		"money_format": "{{amount}} TZS",
		"money_with_currency_format": "{{amount}} TZS"
	  },
	  "TTD": {
		"money_format": "${{amount}}",
		"money_with_currency_format": "${{amount}} TTD"
	  },
	  "TND": {
		"money_format": "{{amount}}",
		"money_with_currency_format": "{{amount}} DT"
	  },
	  "TRY": {
		"money_format": "{{amount}}TL",
		"money_with_currency_format": "{{amount}}TL"
	  },
	  "UGX": {
		"money_format": "Ush {{amount_no_decimals}}",
		"money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
	  },
	  "UAH": {
		"money_format": "?{{amount}}",
		"money_with_currency_format": "{{amount}} UAH"
	  },
	  "AED": {
		"money_format": "Dhs. {{amount}}",
		"money_with_currency_format": "Dhs. {{amount}} AED"
	  },
	  "UYU": {
		"money_format": "${{amount_with_comma_separator}}",
		"money_with_currency_format": "${{amount_with_comma_separator}} UYU"
	  },
	  "VUV": {
		"money_format": "{{amount}} VT",
		"money_with_currency_format": "{{amount}} VT"
	  },
	  "VEF": {
		"money_format": "Bs. {{amount_with_comma_separator}}",
		"money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
	  },
	  "VND": {
		"money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
		"money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
	  },
	  "XBT": {
		"money_format": "{{amount_no_decimals}} BTC",
		"money_with_currency_format": "{{amount_no_decimals}} BTC"
	  },
	  "XOF": {
		"money_format": "CFA{{amount}}",
		"money_with_currency_format": "CFA{{amount}} XOF"
	  },
	  "ZMW": {
		"money_format": "K{{amount_no_decimals_with_comma_separator}}",
		"money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
	  }
	};	
	var
	rangeS = parent.querySelectorAll("input[type=range]"),
	numberS = parent.querySelectorAll("input[type=number]");
	rangeS.forEach(function(el) {
		el.oninput = function() {
			var slide1 = parseFloat(rangeS[0].value),
				slide2 = parseFloat(rangeS[1].value);
			if (slide1 > slide2) {
				[slide1, slide2] = [slide2, slide1];
			}
			numberS[0].value = slide1;
			numberS[1].value = slide2;
			if( $('.bwp_currency').length > 0){ 
				var newCurrency = $('.field-price span.money',parent).attr('data-currency'),
				oldCurrency = window.routes.shop_currency,
				hover_currency = window.routes.hover_currency;
				var newFormat = moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
				var oldFormat = moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
				var cents1 = Currency.convert(parseFloat(slide1, 10) * 100, oldCurrency, newCurrency);
				var cents2 = Currency.convert(parseFloat(slide2, 10)*100, oldCurrency, newCurrency);
				$('.field-price span.from span.money',parent).html(Currency.formatMoney(cents1,newFormat));
				$('.field-price span.to span.money',parent).html(Currency.formatMoney(cents2,newFormat));
				if (hover_currency){
					$('.field-price span.from span.tt_currency_txt',parent).html(slide1);
					$('.field-price span.to span.tt_currency_txt',parent).html(slide2);
				}
			}else{
				var moneyFormat = wpbingo.strings.moneyFormat;
				$('.field-price span.from',parent).html(wpbingo.Currency.formatMoney(parseFloat(slide1, 10) * 100, moneyFormat));
				$('.field-price span.to',parent).html(wpbingo.Currency.formatMoney(parseFloat(slide2, 10)*100, moneyFormat));
			}
			const width = 100*slide2/rangeS[1].max - 100*slide1/rangeS[0].max;
			const left = 100*slide1/rangeS[0].max;
			$('.slider-price',parent).css({"--width": width+"%", "--left": left+"%"});
		}
	});
	numberS.forEach(function(el) {
		el.oninput = function() {
			var number1 = parseFloat(numberS[0].value),
			number2 = parseFloat(numberS[1].value);
					
			if (number1 > number2) {
				var tmp = number1;
				numberS[0].value = number2;
				numberS[1].value = tmp;
			}
			rangeS[0].value = number1;
			rangeS[1].value = number2;
		}
	});
	const width = 100*rangeS[1].value/rangeS[1].max - 100*rangeS[0].value/rangeS[0].max;
	const left = 100*rangeS[0].value/rangeS[0].max;
	$('.slider-price',parent).css({"--width": width+"%", "--left": left+"%"});
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
const KekilliStoneShape = {
  refresh() {
    if (!document.getElementById('kekilli-stone-shape-style')) {
      const style = document.createElement('style');
      style.id = 'kekilli-stone-shape-style';
      style.textContent = '.kekilli-stone-shape .facets__item{display:block!important}.kekilli-stone-shape .facets__display{display:block!important}.kekilli-stone-shape .count,.kekilli-stone-shape .view{display:none!important}';
      document.head.append(style);
    }
    document.querySelectorAll('.FacetFiltersForm').forEach((form, formIndex) => {
      const category = form.querySelector('input[name="filter.p.t.category"][value="aa-6-9-2"]');
      const shapeInput = form.querySelector('input[name="filter.p.m.custom.stone_shape"]');
      const group = shapeInput?.closest('.js-filter');
      if (!group || !category) return;
      group.classList.add('kekilli-stone-shape');
      group.style.cssText = 'margin: 12px 0 12px 20px; padding: 12px 0 0 12px; border-left: 1px solid #ddd; width: auto;';
      group.hidden = !category.checked;
      group.style.display = category.checked ? 'block' : 'none';
      const display = group.querySelector('.facets__display');
      if (display) display.style.display = 'block';
      const list = group.querySelector('.facets__list');
      const shapes = ['Oval', 'Radiant', 'Round', 'Asscher', 'Princess', 'Cushion', 'Heart', 'Marquise', 'Pear', 'Baguette', 'Emerald'];
      list.querySelectorAll('[data-kekilli-preview-shape]').forEach((item) => item.remove());
      shapes.forEach((shape) => {
        const existing = [...list.querySelectorAll('input[name="filter.p.m.custom.stone_shape"]')].find((input) => input.value === shape);
        if (existing) {
          list.append(existing.closest('.facets__item'));
          return;
        }
        const item = document.createElement('li');
        item.className = 'list-menu__item facets__item';
        item.dataset.kekilliPreviewShape = shape;
        const wrapper = document.createElement('div');
        wrapper.className = 'select-filter';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.disabled = true;
        input.id = 'Kekilli-preview-shape-' + shape + '--kekilli-' + formIndex;
        const label = document.createElement('label');
        label.className = 'facet-checkbox facet-checkbox--disabled';
        label.htmlFor = input.id;
        label.textContent = shape;
        const detail = document.createElement('small');
        detail.textContent = ''; input.title = 'No matching products';
        detail.style.cssText = 'display:block;font-size:11px;line-height:1.3;color:#777;margin:0 0 7px;';
        wrapper.append(input, label, detail);
        item.append(wrapper);
        list.append(item);
      });
      group.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (!category.checked) input.checked = false;
      });
      category.closest('.facets__item').append(group);
      form.querySelectorAll('input[id], select[id]').forEach((input) => {
        const oldId = input.id;
        const newId = oldId.replace(/--kekilli-\d+$/, '') + '--kekilli-' + formIndex;
        form.querySelectorAll('label[for]').forEach((label) => {
          if (label.htmlFor === oldId) label.htmlFor = newId;
        });
        input.id = newId;
      });
    });
  }
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => KekilliStoneShape.refresh(), { once: true });
} else {
  KekilliStoneShape.refresh();
}
document.addEventListener('change', (event) => {
  if (event.target.matches('.FacetFiltersForm input[name="filter.p.t.category"]')) {
    KekilliStoneShape.refresh();
  }
});

document.addEventListener('input', (event) => {
  const input = event.target;
  if (!input.matches('.FacetFiltersForm input[name="filter.p.t.category"], .FacetFiltersForm input[name="filter.p.m.custom.stone_shape"]')) return;
  event.stopImmediatePropagation();
  const form = input.closest('form');
  const params = new URLSearchParams(new FormData(form));
  if (!params.getAll('filter.p.t.category').includes('aa-6-9-2')) params.delete('filter.p.m.custom.stone_shape');
  const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
  if (previewTheme) params.set('preview_theme_id', previewTheme);
  sessionStorage.setItem('kekilli-shape-drawer', 'open');
  location.assign(location.pathname + '?' + params.toString());
}, true);
if (sessionStorage.getItem('kekilli-shape-drawer') === 'open') {
  sessionStorage.removeItem('kekilli-shape-drawer');
  document.body.classList.add('collection-sidebar--open');
}
document.addEventListener('click', (event) => {
  const label = event.target.closest('.FacetFiltersForm label[for]');
  const input = label && document.getElementById(label.htmlFor);
  if (input && (input.name === 'filter.p.t.category' || input.name === 'filter.p.m.custom.stone_shape')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (input.disabled) return;
    input.checked = !input.checked;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    return;
  }
  const link = event.target.closest('facet-remove a');
  if (!link || !document.querySelector('.kekilli-stone-shape')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const target = new URL(link.href);
  if (!target.searchParams.getAll('filter.p.t.category').includes('aa-6-9-2')) target.searchParams.delete('filter.p.m.custom.stone_shape');
  const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
  if (previewTheme) target.searchParams.set('preview_theme_id', previewTheme);
  sessionStorage.setItem('kekilli-shape-drawer', 'open');
  location.assign(target.href);
}, true);
new MutationObserver(() => {
  if ([...document.querySelectorAll('input[name="filter.p.m.custom.stone_shape"]')].some(input => !input.closest('.kekilli-stone-shape'))) KekilliStoneShape.refresh();
}).observe(document.querySelector('.js-page-collection') || document.body, { childList: true, subtree: true });






(()=>{if(location.pathname.replace(/\/$/,'')!=='/collections/engagement-rings')return;
const key='filter.v.m.custom.metal_combination',shapeKey='filter.p.m.custom.stone_shape';
const mixed=["18ct Gold / Yellow Gold + Platinum 950","18ct Gold / Yellow Gold + 18ct Gold / White Gold + 18ct Gold / Two Tone","18ct Gold / White Gold + 18ct Gold / Rose Gold + 18ct Gold / Two Tone"],purities=['18ct Gold','14ct Gold','9ct Gold'],colours={yellow:'Yellow Gold',white:'White Gold',rose:'Rose Gold',platinum:'Platinum'};
function setup(){if(document.querySelector('#kekilli-engagement-controls'))return;const grid=document.querySelector('#JsCollectionProduct');if(!grid)return;document.body.classList.add('kekilli-engagement-native');const p=new URLSearchParams(location.search),selected=p.getAll(key);let colour=p.get('km_color')||Object.keys(colours).find(c=>c==='platinum'?selected.includes('Platinum 950'):purities.some(p=>selected.includes(p+' / '+colours[c])))||'';
const form=document.createElement('form');form.id='kekilli-engagement-controls';form.innerHTML='<label>Metal<select name="colour"><option value="">All metals</option><option value="yellow">Yellow Gold</option><option value="white">White Gold</option><option value="rose">Rose Gold</option><option value="platinum">Platinum</option></select></label><label>Metal Purity<select name="purity"><option value="">All purities</option><option>18ct Gold</option><option>14ct Gold</option><option>9ct Gold</option><option>Platinum 950</option></select></label><label>Stone Shape<select name="shape"><option value="">All shapes</option>'+['Oval','Radiant','Round','Emerald','Marquise','Pear','Princess','Cushion'].map(s=>'<option>'+s+'</option>').join('')+'</select></label><label>Maximum Price (AUD)<input name="max" type="number" min="0" placeholder="Any"></label><button type="button">Clear filters</button>';
form.elements.colour.value=colour;form.elements.purity.value=p.get('km_purity')||'';form.elements.shape.value=p.get(shapeKey)||'';form.elements.max.value=p.get('filter.v.price.lte')||'';
const raw=[...document.querySelectorAll('input[name="'+key+'"]')].map(e=>e.value);
function target(){const q=new URLSearchParams(location.search);q.delete('page');q.delete('preview_theme_id');q.delete('filter.p.m.custom.metal_type');q.delete('filter.p.t.category');q.delete(key);const c=form.elements.colour.value,pu=form.elements.purity.value;let values=[...new Set([...raw,...mixed,...purities.flatMap(x=>['Yellow Gold','White Gold','Rose Gold','Two Tone','Three Tone'].map(y=>x+' / '+y)),'Platinum 950','Silver 925'])];if(c||pu){values=values.filter(v=>v.split(' + ').some(pair=>(!c||(c==='platinum'?pair==='Platinum 950':pair.endsWith(' / '+colours[c])))&&(!pu||pair.startsWith(pu))));values.forEach(v=>q.append(key,v));if(!values.length)q.append(key,'__no_matching_metal_combination__');}for(const[k,v]of [['km_color',c],['km_purity',pu],[shapeKey,form.elements.shape.value],['filter.v.price.lte',form.elements.max.value]]){v?q.set(k,v):q.delete(k);}return q;}
function go(q){location.assign(location.pathname+(q.toString()?'?'+q.toString():''));}
form.addEventListener('submit',e=>{e.preventDefault();go(target());});form.addEventListener('change',()=>go(target()));form.querySelector('button').onclick=()=>go(new URLSearchParams());grid.before(form);const style=document.createElement('style');style.textContent='body.kekilli-engagement-native .facets-container,body.kekilli-engagement-native .collection-sidebar{display:none!important}#kekilli-engagement-controls{display:flex;flex-wrap:wrap;align-items:end;gap:14px;margin:20px 0 28px;width:100%}#kekilli-engagement-controls label{display:flex;flex-direction:column;gap:5px;font-size:14px}#kekilli-engagement-controls select,#kekilli-engagement-controls input,#kekilli-engagement-controls button{min-height:40px;padding:8px 12px;border:1px solid #ccc;background:#fff;color:#111}#kekilli-engagement-controls input{width:145px}@media(max-width:749px){#kekilli-engagement-controls label{flex:1 1 42%}#kekilli-engagement-controls select,#kekilli-engagement-controls input{width:100%}}';document.head.append(style);
for(const a of document.querySelectorAll('.page-collection-footer a[href]')){if(!a.getAttribute('href'))continue;const u=new URL(a.href);for(const k of ['km_color','km_purity'])if(p.has(k))u.searchParams.set(k,p.get(k));a.href=u.pathname+u.search;}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();})();